// extracted by mini-css-extract-plugin
export default {"qualityScoreCell":"QualityScoreCell_qualityScoreCell__WG3H5","green":"QualityScoreCell_green__sDDPY","red":"QualityScoreCell_red__QkcU8","orange":"QualityScoreCell_orange__74cbw"};